module.exports = __webpack_public_path__ + "images/emoji/diamond_shape_with_a_dot_inside.bf1651cf69e7249f1ef9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/diamond_shape_with_a_dot_inside.png
// module id = u9i0
// module chunks = 13